import { render, staticRenderFns } from "./notify-form.vue?vue&type=template&id=aa026cda&scoped=true&"
import script from "./notify-form.vue?vue&type=script&lang=js&"
export * from "./notify-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa026cda",
  null
  
)

export default component.exports